import { Section, H2, DataField, P } from "./common-components";

export const Interventions = ({formType}) => {
  // TODO: not built yet
  return (
    <Section formType={formType}>
      <H2>Interventions</H2>
      {/* <div className="space-y-2">
        <div className="grid grid-cols-2 gap-2">
          <DataField label="Name of Drug" value={"Lorem ipsum"} />
          <DataField
            label="Intervention Type"
            value={"Pharmaceutical Opinion"}
          />
          <DataField label="Severity Level" value={"Lorem ipsum"} />
          <DataField label="Urgency Level" value={"Lorem ipsum"} />
        </div>
        <div className="grid grid-rows-1 gap-2">
          <DataField label="Action Plan" value={"Lorem ipsum"} />
          <DataField label="Comments" value={"Lorem ipsum"} />
        </div>
        <DataField className={"!text-teal-300"} label="Complete intervention notes filed as an attachment with the Pharmacist Initial Assessment Form - in Medical Summary" />
      </div> */}
    </Section>
  );
};
